// LOTE NF-1 — helpers de exibição de nome do cliente.
// Regra: quando houver `nome_fantasia`, exibi-lo em destaque e a razão
// social (ou nome) abaixo em texto menor. Sem fantasia → mostra `nome`
// sozinho (comportamento anterior preservado).

export function clienteDisplayName(c) {
  if (!c) return "";
  return (c.nome_fantasia && c.nome_fantasia.trim()) || c.nome || "";
}

export function clienteSecondaryName(c) {
  if (!c) return "";
  const fant = (c.nome_fantasia || "").trim();
  if (!fant) return "";
  const sec = (c.razao_social || c.nome || "").trim();
  if (!sec || sec === fant) return "";
  return sec;
}
